import { Route, Routes } from "react-router-dom";
import { CatalogMaterialProvider } from "./context/CatalogMaterialContext";
import { CatalogMaterialPage } from "./pages/CatalogMaterialPage";

type Props = {};
const CatalogMaterial = (props: Props) => {
  return (
    <CatalogMaterialProvider>
      <Routes>
        <Route index element={<CatalogMaterialPage />}></Route>
        <Route path=":materialId" element={<CatalogMaterialPage />}></Route>
      </Routes>
    </CatalogMaterialProvider>
  );
};
export default CatalogMaterial;
